module.exports = "/assets/fonts/990ae4d0.svg";